import React, { FC } from 'react';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import { graphql } from 'gatsby';

import {
  CustomField,
  CustomImg,
  CustomLabel,
  CustomLink,
  FailedTitle,
} from '../styled';

import orderFailed from '../../../../static/images/ic_TransactionFailed.svg';

interface Props {
  txid: string;
  status: string;
}

const Failed: FC<
  Props & Queries.ThankYouFailedFragment & Queries.ThankYouCommonFragment
> = ({ txid, status, failed, content, links }) => {
  return (
    <>
      <CustomImg src={orderFailed} alt="Order Failed" />
      <FailedTitle>{failed?.title}</FailedTitle>
      {txid && status && (
        <div style={{ textAlign: 'left' }}>
          <CustomLabel>{content?.labels?.transaction}</CustomLabel>
          <CustomField>{txid}</CustomField>
          <CustomLabel>{content?.labels?.status}</CustomLabel>
          <CustomField>{status}</CustomField>
        </div>
      )}
      <Paragraph style={{ textAlign: 'left' }}>{failed?.description}</Paragraph>
      <Paragraph style={{ textAlign: 'left', paddingBottom: '48px' }}>
        {failed?.moreInfo}
        <CustomLink
          href={`${links?.support?.url}?subject=Support for Order ID ${txid}`}
        >
          {links?.support?.title}
        </CustomLink>
      </Paragraph>
    </>
  );
};

export const query = graphql`
  fragment ThankYouFailed on Json {
    failed {
      title
      description
      moreInfo
    }
  }
`;

export default Failed;
